import { Crown, X } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PremiumModal() {
  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => setIsOpen(false);
  const navigate = useNavigate();

  return (
    <div className="">
      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center z-[1100] bg-black/50 "
          onClick={handleClose}
        >
          <div
            className="bg-white mt-20 rounded-2xl shadow-lg max-w-xl w-full p-8 relative"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            {/* Lock Icon */}
            <div className="flex justify-center mb-4">
              <div className="p-4 rounded-full">
                <img src="/PremiumAccess/PaModalLock.png" alt="lock" />
              </div>
            </div>

            {/* Title */}
            <h2 className="font-siromi text-[#8A40B5] text-[24px] text-center">
              Ready To Apply?
            </h2>

            {/* Subtitle */}
            <p className="font-altis mt-4 text-[#666666] text-[16px] text-center mb-6">
              To apply for this course, you need to purchase first.
            </p>

            {/* Features */}
            <ul className="mx-auto space-y-2 mb-6 font-altis text-[14px] text-[#222] max-w-md">
              {[
                "Unlimited access to all premium courses, anytime and anywhere.",
                "A personalized learning roadmap with clear goals and milestones.",
                "Earn a recognized certificate upon successful course completion.",
                "24/7 mentor support to guide you at every step.",
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="flex-shrink-0 h-6 w-6 flex items-center justify-center mt-1">
                    <img src="/PremiumAccess/PaModalTick.png" alt="tick" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            {/* Footer */}
            <div className="flex flex-row items-center gap-2 mb-6">
              <img
                className="h-4 w-4"
                src="/PremiumAccess/PaModalStar.png"
                alt="star"
              />
              <p className="font-altis text-[14px] font-bold text-[#555]">
                Choose a package that suits your learning goals and start your
                journey today!
              </p>
            </div>

            {/* Buttons */}
            <div className="flex justify-center gap-4">
              <button
                onClick={handleClose}
                className="px-4 py-2 bg-gray-200 text-[#572575] rounded-lg font-altis font-bold text-[14px] flex items-center hover:bg-gray-300 transition"
              >
                <X className="mr-1" size={16} /> Not Now
              </button>

              <button
                onClick={() => navigate("/sap/pricing-plan")}
                className="px-4 py-2 bg-[#572575] text-white rounded-lg font-altis font-bold text-[14px] flex items-center gap-2 hover:bg-[#461d5e] transition"
              >
                <Crown size={16} /> View Packages
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
